// extracted by mini-css-extract-plugin
module.exports = {"formulariosearch":"Photos_formulariosearch__2hA4q"};